import React from 'react';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import { Template } from 'devextreme-react/core/template';

import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing,
    FormItem,
    Pager,
    HeaderFilter,
    Form,
    Lookup,
    Grouping,
    GroupPanel,
    Export,
    Scrolling,
    SearchPanel,
    Selection,
    StateStoring
} from 'devextreme-react/data-grid';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import { CheckBox } from 'devextreme-react';
import CustomStore from "devextreme/data/custom_store";
import 'whatwg-fetch';



const allowedPageSizes = [10, 15, 20, 25, 30, 50, 100];

class ExtendedTaxFormReport extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            autoExpandAll: true,
            showColumnLines: true,
            showRowLines: true,
            showBorders: true,
            rowAlternationEnabled: false,
            allowColumnReordering: true,
            wordWrapEnabled: true,
            columnAutoWidth: true,
            showColumnHeaders: true
        };

        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
        this.dataGrid = null;

        this.onAutoExpandAllChanged = this.onAutoExpandAllChanged.bind(this);
    }

    currencyFormat = { style: 'decimal', useGrouping: true };

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'totalGroupCount'
        }, {
            location: 'before',
            widget: 'dxSelectBox',
            options: {
                width: 200,
                items: [{
                    value: 'Id',
                    text: 'Grouping by Id'
                }, {
                    value: 'taxPayerName',
                    text: 'Grouping by Tax Payer Name'
                }],
                displayExpr: 'text',
                valueExpr: 'value',
                value: 'remoteDataSource'
            }
        }
            ,
            {
                location: 'after',
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    onClick: this.refreshDataGrid.bind(this)
                }
            });
    }

    refreshDataGrid() {
        this.dataGrid.instance.refresh();
    }

    render() {
        const { allowColumnReordering, wordWrapEnabled, columnAutoWidth, showColumnHeaders, showColumnLines, showRowLines, showBorders, rowAlternationEnabled } = this.state;
        return (
            <div>
                <DataGrid
                    //DataGrid id="gridContainer"
                    //ref={(ref) => this.dataGrid = ref}
                    dataSource={gridDataSource}
                    keyExpr="id"
                    allowColumnReordering={allowColumnReordering}
                    wordWrapEnabled={wordWrapEnabled}
                    columnAutoWidth={columnAutoWidth}
                    showColumnHeaders={showColumnHeaders}
                    showColumnLines={showColumnLines}
                    showRowLines={showRowLines}
                    showBorders={showBorders}
                    rowAlternationEnabled={rowAlternationEnabled}
                >
                    <ColumnChooser enabled={true} />
                    <ColumnFixing enabled={true} />
                    <Pager
                        showPageSizeSelector={true}
                        allowedPageSizes={allowedPageSizes}
                        showNavigationButtons={true}
                        showInfo={true}
                        infoText="Page {0} of {1} ({2} Tax Records)"
                    />
                    <Export enabled={true} fileName="ExtendedTaxFormReport" allowExportSelectedData={true} />
                    <Selection mode="multiple" />
                    <GroupPanel visible={true} />
                    <HeaderFilter visible={true} />
                    <SearchPanel visible={true} />
                    <Grouping autoExpandAll={this.state.autoExpandAll} />

                    <Column dataField="ein" dataType="string" groupIndex={0} />
                    <Column dataField="taxpayerName" dataType="string" groupIndex={0} fixed={true} />
                    <Column dataField="clubId" dataType="string" />
                    <Column dataField="taxYear" dataType="string" fixed={true} />
                    <Column dataField="addressLine1" dataType="string" visible={false} />
                    <Column dataField="city" dataType="string" format={this.currencyFormat} visible={false} />
                    <Column dataField="state" dataType="string" format={this.currencyFormat} />
                    <Column dataField="zipCode" dataType="string" format={this.currencyFormat} visible={false} />
                    <Column dataField="taxPeriod" dataType="string" />
                    <Column dataField="datetimecreated" dataType="string" visible={false} />
                    <Column dataField="returnVersion" dataType="string" visible={false} />
                    <Column dataField="taxPeriodEndDate" dataType="string" visible={false} />
                    <Column dataField="taxPeriodBeginDate" dataType="string" visible={false} />
                    <Column dataField="totalEmployeeCount" dataType="number" format={this.currencyFormat} />
                    <Column dataField="initiationFeesAmount" dataType="number" format={this.currencyFormat} />
                    <Column dataField="payrollTaxes" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalRevenue" dataType="number" format={this.currencyFormat} />
                    <Column dataField="grossSalesOfInventory" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalAssetsEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalAssetsBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="securedMortgagesAndNotesPayableBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="securedMortgagesAndNotesPayableEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="unsecuredMortgagesAndNotesPayableBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="unsecuredMortgagesAndNotesPayableEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalLiabilitiesBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalLiabilitiesEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalNetAssetsBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalNetAssetsEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalLiabilitiesAndNetAssetsBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalLiabilitiesAndNetAssetsEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="programRelatedInvestmentsBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="programRelatedInvestmentsEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="costOfGoodsSold" dataType="number" format={this.currencyFormat} />
                    <Column dataField="numberFormsTransmittedWith1096" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compensationForCurrentOfficers" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compensationForDisqualifiedPersons" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherSalariesAndWages" dataType="number" format={this.currencyFormat} />
                    <Column dataField="pensionPlanContributions" dataType="number" format={this.currencyFormat} />
                    <Column dataField="depreciationDepletionAmortization" dataType="number" format={this.currencyFormat} />
                    <Column dataField="insurance" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalFunctioningExpenses" dataType="number" format={this.currencyFormat} />
                    <Column dataField="cashNonInterestBearingBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="cashNonInterestBearingEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="savingsAndTemporaryCashInvestmentsBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="savingsAndTemporaryCashInvestmentsEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="landBuildingsEquipmentNetBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="landBuildingsEquipmentNetEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="investmentInPubliclyTradedSecuritiesBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="investmentInPubliclyTradedSecuritiesEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="investmentsOtherSecuritiesBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="investmentsOtherSecuritiesEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="land" dataType="number" format={this.currencyFormat} />
                    <Column dataField="grossReceipts" dataType="number" format={this.currencyFormat} />
                    <Column dataField="programServiceRevenueCy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="investmentIncomeCy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherRevenueCy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="lastProcessedDate" dataType="number" format={this.currencyFormat} />
                    <Column dataField="landBldgEquipCostOrOtherBss" dataType="number" format={this.currencyFormat} />
                    <Column dataField="landBldgEquipAccumDeprec" dataType="number" format={this.currencyFormat} />
                    <Column dataField="savingsAndTempCashInvestmentBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="savingsAndTempCashInvestmentEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalContributions" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalProgramServiceRevenue" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compCurrentOfficersDirectors" dataType="number" format={this.currencyFormat} />
                    <Column dataField="compDisqualPersons" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherEmployeeBenefits" dataType="number" format={this.currencyFormat} />
                    <Column dataField="interest" dataType="number" format={this.currencyFormat} />
                    <Column dataField="depreciationDepletion" dataType="number" format={this.currencyFormat} />
                    <Column dataField="totalFunctionalExpenses" dataType="number" format={this.currencyFormat} />
                    <Column dataField="deferredRevenueBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="deferredRevenueEoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherLiabilitiesBoy" dataType="number" format={this.currencyFormat} />
                    <Column dataField="otherLiabilitiesEoy" dataType="number" format={this.currencyFormat} />

                </DataGrid>
                <div className="options">
                    <div className="caption">Options</div>
                    <div className="option">
                        <CheckBox text="Expand All Groups"
                            value={this.state.autoExpandAll}
                            onValueChanged={this.onAutoExpandAllChanged} />
                    </div>
                </div>
            </div>
        );
    }

    onAutoExpandAllChanged() {
        this.setState({
            autoExpandAll: !this.state.autoExpandAll
        });
    }

}

function handleErrors(response) {
    if (!response.ok)
        throw Error(response.statusText);
    return response;
}
const gridDataSource = {
    store: new CustomStore({
        //key: 'id',
        load: (values) => {
            return fetch("/api/extendedtaxform", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(result => result.json())
                .catch(handleErrors);
        },

        update: (key, values) => {
            console.log('values', values);
            var jsonString = JSON.stringify(values);
            return fetch('/api/ein/' + key, {
                method: "PUT",
                body: jsonString,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(handleErrors);
        }
    })
}

export default ExtendedTaxFormReport;
